export default __webpack_public_path__ + "static/media/screen6.efd3aaf4.png";